import { authInstance } from './base'

const BASE_URL = '/authv2'

export const REFRESH_PATH = `${BASE_URL}/refresh`

export type AccessTokenType = {
  exp: number
  key: number
  login: string
  role: string
}

export type SigninPayload = {
  username: string
  password: string
}

export type SigninResponse = {
  accessToken: string
  userFullName: string
  userRole: 'user' | 'admin'
  paidUpUntil: string | Date | null
  subDaysRemain: number | null
}

export const signInCall = async (
  payload: SigninPayload
): Promise<SigninResponse> => {
  try {
    const formData = new FormData()
    formData.append('username', payload.username)
    formData.append('password', payload.password)
    const response = await authInstance.post(`${BASE_URL}/signin`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true
    })
    return response.data
  } catch (err) {
    if (err && typeof err === 'object' && 'type' in err) {
      const type = err?.type
      if (type && type === 'access.cred_invalid') {
        return await Promise.reject('Wrong login or password')
      }
    }
    if (err && typeof err === 'object' && 'msg' in err) {
      return await Promise.reject(err?.msg ?? 'Проблема соединения с сервером')
    }
    return await Promise.reject(err)
  }
}

export const logoutCall = async (): Promise<void> => {
  try {
    const response = await authInstance.post(`${BASE_URL}/logout`, null, {
      withCredentials: true
    })
    return response.data
  } catch (error: unknown) {
    return await Promise.reject(error ?? 'Не удалось выйти из учетной записи')
  }
}

export const refreshTokenCall = async (): Promise<SigninResponse> => {
  try {
    const response = await authInstance.post(`${BASE_URL}/refresh`, null, {
      withCredentials: true
    })
    return response.data
  } catch (error: unknown) {
    if (error === undefined) {
      throw new Error('Request timeout')
    }
    return await Promise.reject(error)
  }
}

export const getProfileInfoCall = async (): Promise<
  Omit<SigninResponse, 'accessToken'>
> => {
  try {
    const response = await authInstance.post(`${BASE_URL}/profile`, null, {
      withCredentials: true
    })
    return {
      userFullName: response.data.userFullName,
      userRole: response.data.userRole,
      paidUpUntil: response.data?.paidUpUntil ?? null,
      subDaysRemain: response.data?.subDaysRemain ?? null
    }
  } catch (error: unknown) {
    return await Promise.reject(error)
  }
}
